import { Menu } from '@mantine/core';
import IconArrowsJoin from '@tabler/icons-react/dist/esm/icons/IconArrowsJoin.mjs';
import IconLayersUnion from '@tabler/icons-react/dist/esm/icons/IconLayersUnion.mjs';
import { useTranslation } from 'react-i18next';
import type { GraphRendererApi } from '@/shared/ui/graph-renderer';

export const GraphViewSelectionMenu = ({
  api,
  close,
}: {
  api: GraphRendererApi;
  close: () => void;
}) => {
  const { t } = useTranslation();
  const views = api.views;
  if (!views) return null;
  const nodeIds = api.getSelectedNodes().map((node) => node.data.id);
  const edgeIds = views.getSelectedEdges().map((edge) => edge.data.id);
  return (
    <>
      {nodeIds.length > 0 && (
        <Menu.Item
          data-testid='group-selected-menu-item'
          leftSection={<IconLayersUnion />}
          onClick={() => {
            views.group(nodeIds);
            close();
          }}
        >
          {t('graphViews.actions.group', { ns: 'srm' })}
        </Menu.Item>
      )}
      {views.canCollapseEdges(edgeIds) && (
        <Menu.Item
          data-testid='collapse-selected-edges-menu-item'
          leftSection={<IconArrowsJoin />}
          onClick={() => {
            views.collapseEdges(edgeIds);
            close();
          }}
        >
          {t('graphViews.actions.collapse', { ns: 'srm' })}
        </Menu.Item>
      )}
    </>
  );
};
